import { Box, Grid } from "@mui/material";
import PropTypes from "prop-types";

const AuthWrapper = ({ children }: any) => (
  <Box>
    <Box
      style={{ width: "100%" }}
      sx={{
        position: "absolute",
        zIndex: -1,
        bottom: 0,
      }}
    ></Box>
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={11} sm={8} md={4} className="card-register-container">
        {children}
      </Grid>
    </Grid>
  </Box>
);

AuthWrapper.propTypes = {
  children: PropTypes.node,
};

export default AuthWrapper;
